import { UserPermission } from '@ui/shared/model';

export const isAgent = (permissions: UserPermission[] | undefined) =>
  (permissions?.length ?? 0) > 1 &&
  !permissions?.includes(UserPermission.ADMINISTRATION);

export const isAdmin = (permissions: UserPermission[] | undefined) =>
  permissions?.includes(UserPermission.ADMINISTRATION);
